import { createRouter, createWebHistory } from 'vue-router'
import { useAdminAuthStore } from '../store/adminAuth'
import { safeReturnPath } from '../auth/browser-session.mjs'

const routes = [
  { path: '/account-management', component: () => import('../views/AccountManagementView.vue') },
  {
    path: '/',
    redirect: '/admin'
  },
  {
    path: '/login',
    name: 'LoginBridge',
    component: () => import('../views/LoginBridgeView.vue')
  },
  {
    path: '/login-complete',
    name: 'LoginComplete',
    component: () => import('../views/LoginBridgeView.vue'),
    props: { completion: true }
  },
  {
    path: '/d/:slug',
    name: 'DownloadFallback',
    component: () => import('../views/DownloadFallbackView.vue')
  },
  {
    path: '/admin',
    name: 'AdminDashboard',
    component: () => import('../views/AdminDashboardView.vue'),
    meta: { requiresAdmin: true }
  },
  {
    path: '/unauthorized',
    name: 'Unauthorized',
    component: () => import('../views/UnauthorizedView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to, from, next) => {
  const authStore = useAdminAuthStore()

  if (!to.meta.requiresAdmin && to.path !== '/login') {
    return next()
  }

  if (!authStore.profileVerified) {
    try {
      await authStore.fetchProfile()
    } catch (error) {
      if (error.permissionDenied) return next('/unauthorized')
      if (error.response?.status === 401 && to.path !== '/login') {
        return next({ path: '/login', query: { return_to: to.fullPath } })
      }
      if (to.path === '/login') return next()
      return next(false)
    }
  }

  if (to.path === '/login' && authStore.isAuthenticated) {
    return next(safeReturnPath(to.query.return_to || '/admin'))
  }

  if (!authStore.isAdmin) {
    return next('/unauthorized')
  }

  return next()
})

router.afterEach((to) => {
  document.title = to.name === 'DownloadFallback' ? '文件下载 - AutoSquare' : 'AutoSquare资源中心'
})

export default router
